module.exports = __webpack_public_path__ + "img/i_p_close.4503289f.svg";